import styled from 'styled-components';
import { FlexRow } from '@make-software/tg-mini-app-ui';

export const ContentWindow = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    padding: '16px',
    height: '52px',
    backgroundColor: theme.colors.cardBg,
    border: `1px solid ${theme.colors.border}`,
    marginBottom: '20px'
  })
);

export const ButtonWrapper = styled.div(({ theme }) =>
  theme.withMedia({
    fontSize: '12px'
  })
);
